import PropTypes from 'prop-types';
import React from 'react';

import PricingSummary from './PricingSummary';
import PricingSummaryUpdated from './PricingSummaryUpdated';
import PricingSummaryPortal from './PricingSummaryPortal';
import PricingSummaryFooterPortal from './PricingSummaryFooterPortal';

import { priceDetailsScrollEvent } from '../utils/analytics';
import { OFFSET_HEIGHT } from '../constants/constants';

const isBrowser = typeof document === 'object';
export default class PricingSummaryContainer extends React.Component {
	constructor(props) {
		super(props);
		this.viewPriceDetail = this.viewPriceDetail.bind(this);
		this.scrollToAnchor = this.scrollToAnchor.bind(this);
	}

	viewPriceDetail() {
		const { widgetName, windowId } = this.props.widgetInfo;
		priceDetailsScrollEvent(widgetName, windowId);
		this.scrollToAnchor();
	}

	scrollToAnchor() {
		const { deviceType } = this.props.widgetInfo;
		const isMobile = deviceType.toUpperCase() === 'MOBILE';

		let headerSelector =
			document &&
			document.querySelector('[data-widget-id="template-navigation1"]');
		let scrollToSelector = '[data-widget-id="vehicle-title1"]';

		if (isMobile) {
			headerSelector =
				document &&
				document.querySelector('[data-widget-id="template-navbar1"]');
			scrollToSelector = '[data-widget-id="detailed-pricing1"]';
		}
		const pageHeaderHeight =
			(headerSelector && headerSelector.clientHeight) || 0;

		if (DDC && DDC.scrollToAnchor) {
			/* eslint no-undef: 0 */
			DDC.scrollToAnchor($(scrollToSelector), {
				heightAdj: pageHeaderHeight + OFFSET_HEIGHT
			});
		}
	}

	render() {
		const { deviceType } = this.props.widgetInfo;
		const {
			dealerAddress,
			prefs,
			summary,
			widgetInfo,
			showMobilePricingSummary
		} = this.props;
		const isMobile = deviceType.toUpperCase() === 'MOBILE';

		if (isMobile) {
			if (isBrowser) {
				return (
					<React.Fragment>
						{showMobilePricingSummary && (
							<PricingSummaryPortal
								prefs={prefs}
								summary={summary}
								viewPriceDetail={this.viewPriceDetail}
								widgetInfo={widgetInfo}
								dealerAddress={dealerAddress}
								isMobile={isMobile}
							/>
						)}
						<PricingSummaryFooterPortal
							summary={summary}
							viewPriceDetail={this.viewPriceDetail}
							dealerAddress={dealerAddress}
						/>
					</React.Fragment>
				);
			}
			return null;
		}
		return showMobilePricingSummary ? (
			<PricingSummaryUpdated
				prefs={prefs}
				summary={summary}
				viewPriceDetail={this.viewPriceDetail}
				widgetInfo={widgetInfo}
				dealerAddress={dealerAddress}
				isMobile={isMobile}
			/>
		) : (
			<PricingSummary
				prefs={prefs}
				summary={summary}
				viewPriceDetail={this.viewPriceDetail}
				widgetInfo={widgetInfo}
				dealerAddress={dealerAddress}
				isMobile={isMobile}
			/>
		);
	}
}

PricingSummaryContainer.propTypes = {
	prefs: PropTypes.shape({
		showStickySidebarLoanLease: PropTypes.string
	}).isRequired,
	summary: PropTypes.arrayOf(
		PropTypes.shape({
			_type: PropTypes.string.isRequired,
			formatted: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			value: PropTypes.number.isRequired
		})
	).isRequired,
	showMobilePricingSummary: PropTypes.bool,
	widgetInfo: PropTypes.shape({
		windowId: PropTypes.string.isRequired,
		widgetName: PropTypes.string.isRequired,
		deviceType: PropTypes.string.isRequired
	}).isRequired,
	dealerAddress: PropTypes.shape({
		address1: PropTypes.string,
		address2: PropTypes.string,
		address3: PropTypes.string,
		city: PropTypes.string,
		state: PropTypes.string,
		postalCode: PropTypes.string,
		country: PropTypes.string
	})
};

PricingSummaryContainer.defaultProps = {
	dealerAddress: {},
	showMobilePricingSummary: false
};



// WEBPACK FOOTER //
// ./src/components/PricingSummaryContainer.jsx